var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "map-overlay" },
    [
      _vm.isStreetView
        ? _c(
            "div",
            { staticClass: "close-button" },
            [
              _c(
                "md-button",
                {
                  staticClass: "md-white md-icon-button",
                  attrs: { "md-ripple": false },
                  on: { click: _vm.close },
                },
                [_c("md-icon", [_vm._v("close")])],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c("MapSwitchButton"),
      _c("div", {
        class: _vm.isTrialExpired ? "not-paid-map-overlay" : "trip-map",
        attrs: { id: "map_canvas" },
      }),
      !_vm.isStreetView
        ? _c("InfoWindow", { attrs: { "is-date-today": _vm.isDateToday } })
        : _vm._e(),
      _vm.activePanel === "Team Members"
        ? _c(
            "div",
            _vm._l(_vm.driverDetails, function (driver) {
              return _c("DriverMarker", {
                key: driver.publicUserId,
                attrs: {
                  driver: driver,
                  markers: _vm.driverMarkers,
                  "is-date-today": _vm.isDateToday,
                },
                on: { deleteMarker: _vm.handleDeleteDriverMarker },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (ref) {
                        var publicUserId = ref.publicUserId
                        return _vm.stopDetails[publicUserId] &&
                          _vm.stopDetails[publicUserId].length > 0
                          ? [
                              _c(
                                "div",
                                _vm._l(
                                  _vm.getModifiedStops(
                                    _vm.stopDetails,
                                    publicUserId
                                  ),
                                  function (stop) {
                                    return _c("StopMarker", {
                                      key: stop.stopId,
                                      attrs: {
                                        "public-user-id": publicUserId,
                                        stop: stop,
                                        driver: driver,
                                        markers: _vm.stopMarkers,
                                        "stop-order": stop.stopIndex,
                                        "min-distance": _vm.minDistance,
                                      },
                                      on: {
                                        deleteMarker:
                                          _vm.handleDeleteStopMarker,
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                            ]
                          : undefined
                      },
                    },
                  ],
                  null,
                  true
                ),
              })
            }),
            1
          )
        : _c(
            "div",
            _vm._l(_vm.assetGroupDetails, function (assetGroup) {
              return _c("AssetGroupMarker", {
                key: assetGroup.assetGroupId,
                attrs: {
                  "asset-group": assetGroup,
                  markers: _vm.assetMarkers,
                  "is-date-today": _vm.isDateToday,
                },
                on: { deleteMarker: _vm.handleDeleteAssetGroupMarker },
              })
            }),
            1
          ),
      _c("RoutePolyline", {
        attrs: {
          "pinned-driver-details": _vm.pinnedDriverDetails,
          "is-date-today": _vm.isDateToday,
        },
      }),
      _vm.membersLoaded &&
      (_vm.canViewTeamRegion || _vm.isReadOnlyUser) &&
      !_vm.isStreetView
        ? _c("TeamMembersList", {
            attrs: {
              drivers: _vm.driverDetails,
              "render-key": _vm.renderKey,
              "asset-groups": _vm.assetGroupDetails,
            },
            on: {
              changeLoading: function (val) {
                return (_vm.isLoading = val)
              },
            },
          })
        : _vm._e(),
      _vm.isLoading
        ? _c("div", [
            _c(
              "div",
              { staticClass: "map-loader" },
              [
                _c("fade-loader", {
                  attrs: { loading: _vm.isLoading, color: "#000" },
                }),
              ],
              1
            ),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }